<template>
  <!-- Mobile Version -->
  <div
    class="lg:hidden min-h-screen bg-[#007CEF] relative flex flex-col items-center px-4"
  >
    <!-- Decorative Circle -->
    <div class="absolute top-24 w-80 h-80 bg-blue-300/30 rounded-full" />

    <!-- Stacked Cards Container -->
    <div class="relative z-10 mt-32 mb-8 flex justify-center">
      <!-- Third Card (back) - largest, centered -->
      <div class="absolute top-16 w-48 h-24 bg-white rounded-2xl" />
      <!-- Second Card (middle) - medium, centered -->
      <div class="absolute w-56 h-32 bg-white rounded-2xl" />
      <!-- Main Card (front) - smallest, centered -->
      <div class="relative w-64 h-24 bg-white rounded-2xl p-4">
        <!-- Question Indicator -->
        <div class="text-red-500 text-xs font-medium mb-2 text-center">
          01/25
        </div>

        <!-- Question Text -->
        <div
          class="text-gray-800 text-center font-medium text-sm leading-relaxed"
        >
          What is the total number of marbles Budi has now?
        </div>
      </div>

      <!-- Category Badge - positioned to overlay the cards -->
      <div
        class="absolute -bottom-20 left-1/2 transform -translate-x-1/2 bg-blue-900 rounded-2xl w-3/5 h-2/3 px-2 flex items-center gap-2 z-30"
      >
        <div
          class="w-[40px] h-[40px] bg-white rounded-full flex items-center justify-center flex-shrink-0"
        >
          <img
            src="@/assets/book.png"
            alt="Book"
            class="w-[22px] h-[22px]"
          >
        </div>
        <span class="text-white text-sm font-medium">10+<br>Quiz category</span>
      </div>
    </div>

    <!-- Bottom Section - Separated with more spacing -->
    <div class="text-center mb-8 mt-16">
      <h1 class="text-white text-2xl font-bold mb-2">
        Let's start the quiz
      </h1>
      <p class="text-white/90 text-sm">
        Answer all the questions to the best of your ability
      </p>
    </div>

    <!-- Buttons positioned at bottom -->
    <div class="w-full max-w-sm space-y-4 mt-auto mb-8">
      <!-- Premium Button -->
      <button
        class="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-full flex items-center justify-center gap-2 mx-auto"
        @click="goToPremium"
      >
        <i class="fas fa-crown text-sm" />
        <span class="text-sm font-medium">Premium</span>
      </button>

      <!-- Let's Go Button -->
      <button
        class="w-full bg-white hover:bg-gray-50 text-[#007CEF] py-3 rounded-full text-base font-semibold"
        @click="startQuiz"
      >
        Let's Go
      </button>

      <!-- Change My Mind Button -->
      <button
        class="w-full border-2 border-white text-white hover:bg-white/10 py-3 rounded-full text-base font-semibold"
        @click="changeMind"
      >
        Change My Mind
      </button>
    </div>
  </div>

  <!-- Desktop Version -->
  <div class="hidden lg:flex min-h-screen bg-gray-50 flex-col relative">
    <!-- Back Button -->
    <div class="absolute top-6 left-6 z-10">
      <button
        class="flex items-center gap-2 text-gray-600 hover:text-gray-800"
        @click="changeMind"
      >
        <i class="fas fa-arrow-left" />
        <span class="text-lg font-semibold">Back to detail</span>
      </button>
    </div>

    <!-- Premium Button -->
    <div class="absolute top-6 right-6 z-10">
      <button
        class="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-full flex items-center gap-2"
        @click="goToPremium"
      >
        <i class="fas fa-crown text-sm" />
        <span class="text-sm font-medium">Premium</span>
      </button>
    </div>

    <!-- Main Content - Centered -->
    <div class="flex-1 flex flex-col items-center justify-center p-12">
      <!-- Quiz Illustration -->
      <div class="mb-8">
        <img
          src="@/assets/Group.png"
          alt="Quiz Illustration"
          class="w-80 h-auto mx-auto"
        >
      </div>

      <!-- Title -->
      <h1 class="text-3xl font-bold text-gray-900 text-center">
        Let's start the quiz
      </h1>
    </div>

    <!-- Bottom Section with Divider and Buttons -->
    <div class="pb-8 px-12">
      <!-- Horizontal Divider Line -->
      <div class="flex justify-center mb-6">
        <div class="w-4/5 h-px bg-gray-300" />
      </div>

      <!-- Buttons - Side by side -->
      <div class="flex gap-4 w-full max-w-md mx-auto">
        <!-- Change My Mind Button -->
        <button
          class="flex-1 border-2 border-blue-500 text-blue-500 hover:bg-blue-50 py-3 rounded-full text-base font-semibold transition-colors"
          @click="changeMind"
        >
          Change my mind
        </button>

        <!-- Let's Go Button -->
        <button
          class="flex-1 bg-blue-500 hover:bg-blue-600 text-white py-3 rounded-full text-base font-semibold transition-colors"
          @click="startQuiz"
        >
          Let's Go
        </button>
      </div>
    </div>
  </div>

  <!-- Upgrade Modal (menggunakan desain dari SubscribeMobile) -->
  <Transition name="modal">
    <div
      v-if="showUpgrade"
      class="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4"
    >
      <div class="w-full max-w-sm bg-white rounded-3xl shadow-2xl p-6 relative">
        <!-- Modal Header -->
        <div class="flex justify-end items-center mb-2">
          <button
            class="p-2 hover:bg-gray-100 rounded-full"
            @click="showUpgrade = false"
          >
            <i class="fas fa-times text-gray-500" />
          </button>
        </div>

        <!-- Modal Content it's time for upgrade-->
        <div class="text-center mb-4">
          <img
            src="@/assets/crown-uprage-pro.png"
            alt="crown"
            class="w-32 h-32 flex items-center justify-center mx-auto"
          >
          <h4 class="text-lg font-semibold text-gray-900 mb-1">
            It's time for Upgrade!
          </h4>
          <p class="text-gray-600 text-sm">
            Upgrade to remove ads, unlimited play and access all game only with
            $2/month
          </p>
        </div>

        <!-- Modal Actions -->
        <div>
          <button
            class="w-full bg-blue-600 text-white py-3 rounded-full text-base font-semibold hover:bg-blue-700"
            @click="goUpgrade"
          >
            Upgrade Now
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { useRoute, useRouter } from "vue-router";
import { ref, computed } from "vue";
import { useAuthStore } from "@/stores/authStore";
import { CheckDailyLimitByStudent } from "@/api/quizApi";

const router = useRouter();
const route = useRoute();
const quizId = route.params.id;
const auth = useAuthStore();

const showUpgrade = ref(false);
const savedAuthUser = (() => {
  try { return JSON.parse(localStorage.getItem('auth_user') || 'null'); } catch { return null; }
})();
const studentId = computed(() =>
  auth?.userId || auth?.user?.userId || auth?.user?.data?.userId ||
  savedAuthUser?.data?.userId || savedAuthUser?.userId || null
);

function changeMind() {
  router.push("/quiz");
}

async function startQuiz() {

  try {
    if (!studentId.value) {

      router.push({
        path: `/quiz-session/${quizId}`,
        query: {
          ...route.query,
          freshStart: 'true'
        }
      });
      return;
    }

    const data = await CheckDailyLimitByStudent(studentId.value);

    if (data?.limitReached) {
      showUpgrade.value = true;
    } else {
      router.push({
        path: `/quiz-session/${quizId}`,
        query: {
          ...route.query,
          freshStart: 'true'
        }
      });
    }
  } catch (e) {
    console.warn("checkDailyLimit failed:", e?.message || e);

    router.push({
      path: `/quiz-session/${quizId}`,
      query: {
        ...route.query,
        freshStart: 'true'
      }
    });
  }
}


function goUpgrade(){
  router.push('/subscribe');
}

function goToPremium(){
  router.push('/subscribe?showUpgradePremiumScreen=true');
}
</script>

<style scoped>
/* Modal animation */
.modal-enter-active,
.modal-leave-active {
  transition: all 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .w-full.max-w-sm,
.modal-leave-to .w-full.max-w-sm {
  transform: scale(0.9) translateY(20px);
}
</style>
